"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const joi_1 = __importDefault(require("joi"));
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const toLower_1 = __importDefault(require("lodash/toLower"));
const constants_1 = require("../constants");
const utils_1 = require("../../utils");
const common_1 = __importDefault(require("./common"));
const validator = (schema) => (payload) => schema.validate(payload, { abortEarly: false, convert: true });
// regex that matches only values in AllTrackableMeasurements
const allTrackableMeasurementsRegex = new RegExp(`^(${Object.keys(constants_1.AllTrackableMeasurements).join("|")})$`);
const AllTrackableMeasurementsSchema = {
    bodyFat: common_1.default.percentage,
    weight: common_1.default.bodyWeight,
    bench: common_1.default.exerciseWeight,
    squat: common_1.default.exerciseWeight,
    deadlift: common_1.default.exerciseWeight,
    chest: common_1.default.bodySize,
    bust: common_1.default.bodySize,
    upperArm: common_1.default.bodySize,
    waist: common_1.default.bodySize,
    thighs: common_1.default.bodySize,
    calves: common_1.default.bodySize,
    hips: common_1.default.bodySize,
    pelotonRide: common_1.default.count,
    row2k: common_1.default.exerciseTime,
    row5k: common_1.default.exerciseTime,
    run5km: common_1.default.exerciseTime,
    run10km: common_1.default.exerciseTime,
};
const ProgressPictureSchema = joi_1.default
    .object({
    date: common_1.default.date.required(),
    privacy: common_1.default.postPrivacy,
    goal: common_1.default.goal,
    trackedMetrics: common_1.default.trackedMetrics,
})
    .rename(allTrackableMeasurementsRegex, (0, camelCase_1.default)("{#1}"))
    .keys(Object.assign({}, AllTrackableMeasurementsSchema));
const ProgressPictureArraySchema = joi_1.default.array().items(ProgressPictureSchema);
const ProgressPictureObjectSchema = joi_1.default.object().pattern(common_1.default.token, ProgressPictureSchema);
const TransformationSchema = joi_1.default.object({
    dob: common_1.default.date,
    gender: common_1.default.gender,
    height: common_1.default.height,
    postPrivacy: common_1.default.postPrivacy.default((0, toLower_1.default)(constants_1.PostPrivacy.PUBLIC)),
    title: common_1.default.title,
    diets: common_1.default.diets,
    activities: common_1.default.activities,
    supplements: common_1.default.supplements,
    trackedMetrics: common_1.default.trackedMetrics,
    metricTargets: joi_1.default.object(Object.assign({}, AllTrackableMeasurementsSchema)),
    progressPictures: joi_1.default.alternatives().try(ProgressPictureArraySchema, ProgressPictureObjectSchema),
    defaultProgressView: joi_1.default.object({
        after: common_1.default.token,
        before: common_1.default.token,
        imageAngle: common_1.default.token,
    }),
});
const PostPersonalTransformationSchema = joi_1.default
    .object({ transformation: TransformationSchema })
    .custom((value, helpers) => {
    const { transformation } = value;
    console.log({ transformation });
    // if transformation.progressPictures is an array, then it must be an object
    if (transformation.progressPictures && Array.isArray(transformation.progressPictures)) {
        transformation.progressPictures = (0, utils_1.progressPicturesArrayToObject)(transformation.progressPictures);
    }
    return transformation;
});
const UpdatePersonalTransformationSchema = TransformationSchema.concat(joi_1.default.object({
    progressPictures: joi_1.default.any().forbidden(),
}));
const AddProgressPictureSchema = ProgressPictureSchema;
const UpdateProgressPictureSchema = ProgressPictureSchema.concat(joi_1.default.object({
    date: common_1.default.date,
}));
const UpdateProgressPictureImageSchema = joi_1.default.object({
    imageFilenameToReplace: joi_1.default.string().required(),
    imageAngle: common_1.default.selectOneFromOptionsValidation(constants_1.ImageAngle).required(),
});
// TODO: implement schema
const PostClientTransformationSchema = joi_1.default.object({});
module.exports = {
    PostPersonalTransformationSchema: validator(PostPersonalTransformationSchema),
    UpdateUserTransformationSchema: validator(UpdatePersonalTransformationSchema),
    AddProgressPictureSchema: validator(AddProgressPictureSchema),
    UpdateProgressPictureSchema: validator(UpdateProgressPictureSchema),
    UpdateProgressPictureImageSchema: validator(UpdateProgressPictureImageSchema),
    PostClientTransformationSchema: validator(PostClientTransformationSchema),
};
//# sourceMappingURL=transformation.js.map